import styled, { keyframes } from "styled-components";

const $color = (opacity = 1) => `rgba(255, 255, 255, ${opacity})`;
const $duration = "1s";
const DotsLoaderAnimation = (multiplier = 2) => keyframes`
  0% {
            box-shadow: ${3 * multiplier}px 0 0 0 ${$color()},
            ${6 * multiplier}px 0 0 0 ${$color(0.2)},
            ${9 * multiplier}px 0 0 0 ${$color(0.2)};
    }

        33% {
            box-shadow: ${3 * multiplier}px 0 0 0 ${$color(0.2)},
            ${6 * multiplier}px 0 0 0 ${$color()},
            ${9 * multiplier}px 0 0 0 ${$color(0.2)};
    }

        66% {
            box-shadow: ${3 * multiplier}px 0 0 0 ${$color(0.2)},
            ${6 * multiplier}px 0 0 0 ${$color(0.2)},
            ${9 * multiplier}px 0 0 0 ${$color()};
    }
        100% {
            box-shadow: ${3 * multiplier}px 0 0 0 ${$color(0.2)},
            ${6 * multiplier}px 0 0 0 ${$color(0.2)},
            ${9 * multiplier}px 0 0 0 ${$color(0.2)};
    }
`;

export const DotsLoader = styled.div<{ multiplier?: number; dotWidth?: number }>`
    width: ${({ dotWidth = 4 }) => dotWidth}px;
    height: ${({ dotWidth = 4 }) => dotWidth}px;
    border-radius: 50%;
    animation: ${DotsLoaderAnimation()} ${$duration} linear infinite;
    background-color: transparent;
    transform: translateX(-12px);
`;
